import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ListquizcategorySlice } from "../../../redux/features/Quiz Management/QuizCategory";
import {CreateQuizManagementSlice} from '../../../redux/features/Quiz Management/QuizManagementByManual'
import { toast } from "react-toastify";
import { IoMdClose } from "react-icons/io";

const AddQUIZ = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [categoryList, setCategoryList] = useState([]);
  const [errorCustom, setErrorCustom] = useState([
    {
      question: "",
      option1: "",
      option2: "",
      option3: "",
      option4: "",
      optionanswer: "",
      hint: "",
    },
  ]);
  const [optionSet, setOptionSet] = useState({
    option1: "",
    option2: "",
    option3: "",
    option4: "",
  });
  const [iState, setUpdate] = useState({
    quizDetail: {
      quizcategory: "",
      categoryIcon: "",
      level: "",
      numberofquestion: "",
      optionsforanswers: "",
      duration: "",
      papername: "",
      isTrending: false,
    },
    questionDetail: [
      {
        question: "",
        option1: "",
        option2: "",
        option3: "",
        option4: "",
        optionanswer: "",
        hint: "",
      },
    ],
    isAdmin:true,
  }); 

  useEffect(() => {
    Object.entries(iState?.questionDetail?.[0])?.forEach(
      ([key, value], index) => {
        if (!["question", "optionanswer", "hint"]?.includes(key)) {
          setOptionSet((prev) => ({ ...prev, [key]: value }));
        }
      }
    );
  }, [iState?.questionDetail]);

  const AddMore = () => {
    setUpdate((prev) => ({
      ...prev,
      questionDetail: [
        ...prev["questionDetail"],
        {
          question: "",
          option1: "",
          option2: "",
          option3: "",
          option4: "",
          optionanswer: "",
          hint: "",
        },
      ],
    }));

    setErrorCustom((prev) => [
      ...prev,
      {
        question: "",
        option1: "",
        option2: "",
        option3: "",
        option4: "",
        optionanswer: "",
        hint: "",
      },
    ]);
  };

  const hanldeQuiz = (e, field, index) => {
    const { name, value } = e.target;

    if (field === "quizDetail") {
      setUpdate((prev) => ({
        ...prev,
        [field]: { ...prev[field], [e.target.name]: e.target.value },
      }));
    } else {
      setUpdate((prev) => {
        const temp = prev["questionDetail"];

        temp[index] = {
          ...temp[index],
          [name]: value,
        };

        return {
          ...prev,
          questionDetail: temp,
        };
      });
    }
  };

  useEffect(() => {
    dispatch(ListquizcategorySlice()).then((res) => {
      if (res?.payload?.customStatus === 200) {
        setCategoryList(res.payload?.data);
      }
    });
  }, []);

  useEffect(() => {
    setUpdate((prev) => ({
      ...prev,
      quizDetail: {
        ...prev["quizDetail"],
        numberofquestion: iState?.questionDetail?.length,
      },
    }));
  }, [iState?.questionDetail?.length]);

  useEffect(() => {
    const filteredData = categoryList?.find(
      (item) => item.categoryName === iState["quizDetail"]["quizcategory"]
    );

    setUpdate((prev) => ({
      ...prev,
      ["quizDetail"]: {
        ...prev["quizDetail"],
        ["categoryIcon"]: filteredData?.categoryImage,
      },
    }));
  }, [iState["quizDetail"]["quizcategory"]]);

  const hanldeRemove = (index) => {
    setUpdate((prev) => ({
      ...prev,
      questionDetail: [
        ...prev["questionDetail"]?.filter((item, i) => index !== i),
      ],
    }));
  };

  const submit = () => {

    let isAllFieldFine = false;

    if (iState?.quizDetail?.quizcategory?.length === 0) {
      return toast.error("Please select category");
    }

    if (iState?.quizDetail?.level?.length === 0) {
      return toast.error("Please select level");
    }

    // if(iState?.quizDetail?.numberofquestion?.length !== 0){
    //   return toast.error('Please enter number of question');
    // }

    if (iState?.quizDetail?.optionsforanswers?.length === 0) {
      return toast.error("Please enter number of options for answers");
    }

    if (iState?.quizDetail?.duration?.length === 0) {
      return toast.error("Please select duration");
    }

    if (iState?.quizDetail?.papername?.length === 0) {
      return toast.error("Please enter question paper name");
    }

    iState?.questionDetail?.forEach((item,index)=>{
      const temp = [...errorCustom];
      Object.entries(item)?.forEach(([key,value],i)=>{
            if(value?.length === 0){
              temp[index][key] = "please enter this field"
              isAllFieldFine = false;
            }else{
              temp[index][key] = ""
              isAllFieldFine = true;
            }
          })
          setErrorCustom(temp);
    })
    
    if(isAllFieldFine){
      console.log(iState);
      dispatch(CreateQuizManagementSlice(iState))?.then((res)=>{
        if(res?.payload?.customStatus === 200){
          navigate(-1);
        }
      })
    }
  };

  return (
    <>
      <>
        <div className="TitleBox">
          <h4 className="Title">Quiz Management</h4>
          <span>
            <a className="TitleLink" onClick={() => navigate(-1)}>
              <i className="fa fa-arrow-left" />
              Back
            </a>
          </span>
        </div>
        <div className="Small-Wrapper">
          <div className="CommonForm">
            <h4>Add Quiz</h4>
            <div className="row">
              <div className="col-12" style={{ marginBottom: "20px" }}>
                <span
                  title="is this quiz in trending ?"
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    gap: "10px",
                    width: "fit-content",
                  }}
                  onClick={() =>
                    setUpdate((prev) => ({
                      ...prev,
                      quizDetail: {
                        ...prev["quizDetail"],
                        isTrending: !iState?.quizDetail?.isTrending,
                      },
                    }))
                  }
                >
                  <input
                    type="radio"
                    checked={iState?.quizDetail?.isTrending}
                  />
                  <p>isTrending</p>
                </span>
              </div>
              <div className="col-4">
                {" "}
                <div className="form-group">
                  <label>Select Quiz Category</label>
                  <select
                    className="form-control"
                    name="quizcategory"
                    onChange={(e) => hanldeQuiz(e, "quizDetail")}
                  >
                    <option>Select</option>
                    {categoryList?.map((item, index) => {
                      return (
                        <option value={item?.categoryName}>
                          {item?.categoryName}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="col-4">
                {" "}
                <div className="form-group">
                  <label>Level</label>
                  <select
                    className="form-control"
                    name="level"
                    onChange={(e) => hanldeQuiz(e, "quizDetail")}
                  >
                    <option>Select</option>
                    <option value={"Medium"}>Medium</option>
                    <option value={"High"}>High</option>
                    <option value={"Low"}>Low</option>
                  </select>
                </div>
              </div>
              <div className="col-4">
                {" "}
                <div className="form-group">
                  <label>Choose Number of Questions</label>
                  <input
                    type="text"
                    className="form-control"
                    value={iState?.questionDetail?.length || 0}
                    disabled
                  />
                </div>
              </div>
              <div className="col-4">
                {" "}
                <div className="form-group">
                  <label>Choose options for Answers</label>
                  <select
                    className="form-control"
                    name="optionsforanswers"
                    onChange={(e) => hanldeQuiz(e, "quizDetail")}
                  >
                    <option>select</option>
                    <option value={2}>2</option>
                    <option value={3}>3</option>
                    <option value={4}>4</option>
                  </select>
                </div>
              </div>
              <div className="col-4">
                {" "}
                <div className="form-group">
                  <label>Duration</label>
                  <select
                    className="form-control"
                    name="duration"
                    onChange={(e) => hanldeQuiz(e, "quizDetail")}
                  >
                    <option>select</option>
                    <option value={50}>50 min</option>
                    <option value={30}>30 min</option>
                    <option value={20}>20 min</option>
                    <option value={10}>10 min</option>
                    <option value={5}>5 min</option>
                    <option value={2}>2 min</option>
                  </select>
                </div>
              </div>
              <div className="col-4">
                {" "}
                <div className="form-group">
                  <label>Question Paper Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Biotechnology"
                    name="papername"
                    onChange={(e) => hanldeQuiz(e, "quizDetail")}
                  />
                </div>
              </div>
            </div>

            <div className="Small-Wrapper">
              {iState?.questionDetail?.map((_, index) => {
                return (
                  <>
                    <div className="row">
                      <div className="col-12">
                        {iState?.["questionDetail"]?.length > 1 && (
                          <div
                            className="position-relative"
                            onClick={() => hanldeRemove(index)}
                          >
                            <IoMdClose
                              className="border border-secondary rounded-circle text-white bg-secondary"
                              style={{
                                position: "absolute",
                                top: "-29",
                                right: "-27",
                                fontSize: "20px",
                                cursor: "pointer",
                              }}
                            />
                          </div>
                        )}
                        <div className="form-group">
                          <label>Question {index + 1}</label>
                          <input
                            type="text"
                            name="question"
                            value={iState["questionDetail"][index]["question"]}
                            onChange={(e) =>
                              hanldeQuiz(e, "questionDetail", index)
                            }
                            className="form-control"
                            placeholder="The bacterium Arobacterium tumeficians is used to obtain which of the following ?"
                          />
                          {errorCustom?.[index]?.question?.length > 0 && (
                            <div className="text-danger">
                              Please enter the question!
                            </div>
                          )}
                        </div>
                      </div>
                      {Object.keys(optionSet)
                        ?.slice(0, iState?.quizDetail?.optionsforanswers)
                        ?.map((item, i) => {
                          return (
                            <div className="col-4">
                              {" "}
                              <div className="form-group">
                                <label>Option {i + 1}</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Bt-toxin"
                                  name={item}
                                  value={iState["questionDetail"][index][item]}
                                  onChange={(e) =>
                                    hanldeQuiz(e, "questionDetail", index)
                                  }
                                />
                                {errorCustom?.[index]?.[item]?.length > 0 && (
                                  <div className="text-danger">
                                    Please enter the question!
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      <div className="col-4">
                        <div className="form-group">
                          <label>Choose options for Answers</label>
                          <select
                            className="form-control"
                            name="optionanswer"
                            value={
                              iState["questionDetail"][index]["optionanswer"]
                            }
                            onChange={(e) =>
                              hanldeQuiz(e, "questionDetail", index)
                            }
                          >
                            <option>Select</option>
                            {Object.entries(iState?.questionDetail[index])?.map(
                              ([key, value], i) => {
                                if (
                                  ![
                                    "question",
                                    "optionanswer",
                                    "hint",
                                  ]?.includes(key) &&
                                  value?.length !== 0
                                ) {
                                  return <option value={value}>{value}</option>;
                                }
                              }
                            )}
                          </select>
                          {errorCustom?.[index]?.optionanswer?.length > 0 && (
                            <div className="text-danger">
                              Please enter the question!
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="form-group">
                          <label>Hint</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="The bacterium Arobacterium tumeficians is used to obtain which of the following ?"
                            name="hint"
                            value={iState["questionDetail"][index]["hint"]}
                            onChange={(e) =>
                              hanldeQuiz(e, "questionDetail", index)
                            }
                          />
                          {errorCustom?.[index]?.hint?.length > 0 && (
                            <div className="text-danger">
                              Please enter the question!
                            </div>
                          )}
                        </div> 
                      </div>
                    </div>
                    {index !== iState?.questionDetail?.length - 1 && (
                      <div
                        style={{
                          border: "1px solid black",
                          width: "100%",
                          margin: "20px 0",
                        }}
                      ></div>
                    )}
                  </>
                );
              })}
              <button className="Button" onClick={AddMore}>
                Add More +
              </button>
            </div>

            <button className="Button mt-4" onClick={submit}>
              Create
            </button> 
          </div>
        </div>
      </>
    </>
  );
};

export default AddQUIZ;
